/* rm-blackline.js
   Behavior for sections/rm-blackline-product.liquid: bike/size/color selection,
   real variant matching (Color / Bike Model / Size options), fitment notes from
   assets/rm-fitment-notes.json, and add to cart through Savor's own cart AJAX
   endpoint, dispatching the same "shopify:cart:lines-update" event Savor's
   product-form.js dispatches (see assets/product-form.js and the vendored
   @shopify/events module at https://cdn.shopify.com/storefront/standard-events.js)
   so Savor's own cart drawer, cart icon badge and header actions update without
   any change to those files.
*/
(function () {
  'use strict';

  var CART_LINES_UPDATE = 'shopify:cart:lines-update';

  /* Variant prices in the product JSON are integers in the shop's minor unit
     (cents), so 69900 is $699.00. Format them with the shop money format the
     section passes down, falling back to $#,##0.00 when it is missing. */
  var moneyFormat = '${{amount}}';

  function group(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function amount(cents, decimals, thousandsSep, decimalSep) {
    var num = Math.round(Number(cents) || 0);
    var neg = num < 0;
    num = Math.abs(num);
    var whole = String(Math.floor(num / 100));
    var frac = String(num % 100 + 100).slice(1);
    var out = group(whole, thousandsSep);
    if (decimals) out += decimalSep + frac;
    return (neg ? '-' : '') + out;
  }

  function money(cents) {
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, key) {
      switch (key) {
        case 'amount':
          return amount(cents, true, ',', '.');
        case 'amount_no_decimals':
          return amount(cents, false, ',', '.');
        case 'amount_with_comma_separator':
          return amount(cents, true, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return amount(cents, false, '.', ',');
        case 'amount_with_apostrophe_separator':
          return amount(cents, true, "'", '.');
        case 'amount_no_decimals_with_space_separator':
          return amount(cents, false, ' ', '.');
        case 'amount_with_space_separator':
          return amount(cents, true, ' ', ',');
        case 'amount_with_period_and_space_separator':
          return amount(cents, true, ' ', '.');
        default:
          return amount(cents, true, ',', '.');
      }
    });
  }

  /* Sizes the page never picks on its own, from the section setting "Sizes never
     preselected" (passed as |a|b|). The 17 x 1.60 / 14 x 1.85 values are being
     moved to the front of the Size option (Peter, 2026-10-06), so without this the
     page would open on them. A shopper can still click one, and an explicit ?variant= still opens one,
     because both set the size directly instead of going through these. */
  function parseSkipSizes(raw) {
    var out = {};
    String(raw || '').split('|').forEach(function (s) {
      s = s.trim();
      if (s) out[s] = true;
    });
    return out;
  }

  /* The variant to open on when none is named: the first available variant in a
     size that may be preselected, else the first available, else the first. */
  function firstPreselectable(list, sizeIdx, skip) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].available && !(sizeIdx > -1 && skip[list[i].options[sizeIdx]])) return list[i];
    }
    for (i = 0; i < list.length; i++) if (list[i].available) return list[i];
    return list[0] || null;
  }

  /* The size to fall back to when the current one is not offered for the bike:
     the first offered size that may be preselected, else the first offered. */
  function fallbackSize(offered, skip) {
    for (var i = 0; i < offered.length; i++) if (!skip[offered[i]]) return offered[i];
    return offered[0] || null;
  }

  function init(root) {
    var dataEl = root.querySelector('[data-role="variants-data"]');
    if (!dataEl) return;
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var optionNames = data.optionNames || [];
    var variants = data.variants || [];

    /* Liquid caps product.variants at 250 and the mega products carry more than
       that, so the section paginates them. Pull the remaining pages through the
       Section Rendering API and merge them in, otherwise every bike, size and
       colour past variant 250 looks unavailable. */
    var variantPages = Number(dataEl.getAttribute('data-pages') || 1) || 1;
    var loadedPage = Number(dataEl.getAttribute('data-page') || 1) || 1;
    var colorIdx = optionNames.indexOf('Color');
    var bikeIdx = optionNames.indexOf('Bike Model');
    var sizeIdx = optionNames.indexOf('Size');

    var fam = root.dataset.fam;
    var isRtr = root.dataset.rtr === 'true';
    var staticBike = root.dataset.staticBike || null;
    var cartAddUrl = root.dataset.cartAddUrl;
    var productId = root.dataset.productId;
    var skipSizes = parseSkipSizes(root.dataset.skipSizes);
    if (root.dataset.moneyFormat) moneyFormat = root.dataset.moneyFormat;

    var form = document.getElementById('rm-blackline-form');
    var variantInput = form ? form.querySelector('[data-role="variant-id"]') : null;
    var bikeSelect = root.querySelector('[data-role="bike-select"]');
    var sizeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-role="size-btn"]'));
    var colorButtons = Array.prototype.slice.call(root.querySelectorAll('[data-role="color-btn"]'));
    var priceEl = root.querySelector('[data-role="price"]');
    var atcBtn = root.querySelector('[data-role="atc-btn"]');
    var atcText = root.querySelector('[data-role="atc-text"]');
    var sizeNoteEl = root.querySelector('[data-role="size-note"]');
    var sizeConfirmWrap = root.querySelector('[data-role="size-confirm"]');
    var sizeConfirmInput = root.querySelector('[data-role="size-confirm-input"]');
    var rtrTireEl = root.querySelector('[data-role="rtr-tire"]');
    var tirePickEl = root.querySelector('[data-role="tire-pick"]');
    var tireListEl = root.querySelector('[data-role="tire-list"]');
    var expressEl = root.querySelector('[data-role="express"]');
    var productHandle = root.dataset.productHandle || '';
    var productTitle = root.dataset.productTitle || '';
    var galImg = root.querySelector('[data-role="gal-img"]');
    var galThumbsWrap = root.querySelector('[data-role="gal-thumbs"]');
    var galThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-role="gal-thumb"]'));

    /* Every product photo, in the order they sit on the product. The gallery
       leads with the selected colour's image and then offers these, so the
       other angles and detail shots stay reachable. */
    var productMedia = [];
    (function () {
      var el = root.querySelector('[data-role="media-data"]');
      if (!el) return;
      try {
        var parsed = JSON.parse(el.textContent);
        if (Array.isArray(parsed)) productMedia = parsed.filter(Boolean);
      } catch (e) {
        /* leave productMedia empty; the server-rendered thumbs stay as they are */
      }
    })();
    var builderLink = root.querySelector('.rm-builderlink a');

    /* "Most popular" on a size button and on the standard tire (Peter, 2026-10-20).
       Which ones, and the sales behind them, live in snippets/rm-popular.liquid,
       shared with the custom builder. Single front or rear wheels carry none. */
    var popular = window.rmPopular || {};
    var popSetup = fam === 'or' || fam === 'rtror' ? 'offroad' : fam === 'sm' || fam === 'rtrsm' ? 'supermoto' : '';
    var POP_BADGE =
      '<span class="rm-pop"><svg viewBox="0 0 16 16" width="13" height="13" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M8 1.1l2.1 4.4 4.8.6-3.5 3.3.9 4.8L8 11.9l-4.3 2.3.9-4.8L1.1 6.1l4.8-.6z"/></svg>Most popular</span>';
    function popKey(t) {
      return String(t || '').toLowerCase().replace(/["\s]/g, '');
    }
    function popularSize(size) {
      if (!popSetup) return false;
      var bike = (String(state.bike || staticBike || '') + ' ' + productHandle).toLowerCase();
      return (popular.sizes || []).some(function (p) {
        return p.setup === popSetup && popKey(p.size) === popKey(size) && (!p.bike || bike.indexOf(p.bike) > -1);
      });
    }

    /* Bike Model option value to bike_platform handle for the builder deep link.
       The section emits every metaobject name and handle; both are folded to
       lowercase alphanumerics here because the option values punctuate and
       abbreviate differently ("E-Ride PRO 3.0/SR" against the handle
       e-ride-pro-3-0-sr). */
    var bikeHandleMap = {};
    (function () {
      var el = root.querySelector('[data-role="bike-handles"]');
      if (!el) return;
      var raw;
      try {
        raw = JSON.parse(el.textContent);
      } catch (e) {
        return;
      }
      if (!raw) return;
      Object.keys(raw).forEach(function (k) {
        var key = bikeKey(k);
        if (key && raw[k]) bikeHandleMap[key] = raw[k];
      });
    })();

    function bikeKey(s) {
      return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    function bikeHandleFor(value) {
      var key = bikeKey(value);
      if (!key) return null;
      if (bikeHandleMap[key]) return bikeHandleMap[key];
      /* Some option values are neither a metaobject name nor a handle: the RTR
         supermoto product splits Stark Varg into "Stark Varg MX" and "Stark Varg
         EX" against the single stark-varg row, and the combined Talaria product
         offers one "Talaria MX3/MX4/XXX" value against the two rows talaria-mx3
         and talaria-mx4-xxx. Fall back to the longest map key the value starts
         with, which resolves both without naming a bike in the theme. */
      var best = null;
      Object.keys(bikeHandleMap).forEach(function (k) {
        if (k.length < 6) return;
        if (key.indexOf(k) !== 0) return;
        if (!best || k.length > best.length) best = k;
      });
      return best ? bikeHandleMap[best] : null;
    }

    function updateBuilderLink() {
      if (!builderLink) return;
      var handle = bikeHandleFor(state.bike);
      if (!handle && !bikeSelect) return;
      try {
        var u = new URL(builderLink.getAttribute('href'), window.location.origin);
        if (handle) {
          u.searchParams.set('bike', handle);
        } else {
          u.searchParams.delete('bike');
        }
        builderLink.setAttribute('href', u.pathname + u.search);
      } catch (e) {}
    }

    var notesData = [];
    /* Folded notes-row bike name to the exact string the rows carry. */
    var noteBikeNames = {};
    var noteBikeCache = {};
    if (window.rmFitmentNotesUrl) {
      fetch(window.rmFitmentNotesUrl).then(function (r) { return r.json(); }).then(function (d) {
        notesData = d || [];
        noteBikeNames = {};
        noteBikeCache = {};
        notesData.forEach(function (r) {
          if (r && r.bike) noteBikeNames[noteBikeKey(r.bike)] = r.bike;
        });
        refreshNote();
      }).catch(function () {});
    }

    /* The notes rows are keyed by the bike_platform row name, and a product
       option value does not always spell that name the same way: one option
       value can stand for two rows the platform was split into that carry
       identical fitment, and some option values carry a model word the rows
       leave out. Fold to lowercase alphanumerics, drop that model word, then
       fall back to the longest row name the option value starts with. Nothing
       here names a bike, so a later split or rename in the fitment data needs
       no theme change. */
    function noteBikeKey(s) {
      return String(s == null ? '' : s)
        .toLowerCase()
        .replace(/sting/g, '')
        .replace(/[^a-z0-9]/g, '');
    }

    function noteBikeFor(value) {
      if (Object.prototype.hasOwnProperty.call(noteBikeCache, value)) {
        return noteBikeCache[value];
      }
      var key = noteBikeKey(value);
      var resolved = null;
      if (key) {
        if (noteBikeNames[key]) {
          resolved = noteBikeNames[key];
        } else {
          var best = null;
          Object.keys(noteBikeNames).forEach(function (k) {
            if (k.length < 6) return;
            if (key.indexOf(k) !== 0) return;
            if (!best || k.length > best.length) best = k;
          });
          if (best) resolved = noteBikeNames[best];
        }
      }
      noteBikeCache[value] = resolved;
      return resolved;
    }

    function findVariantById(id) {
      var idNum = Number(id);
      for (var i = 0; i < variants.length; i++) {
        if (Number(variants[i].id) === idNum) return variants[i];
      }
      return null;
    }

    /* An explicit ?variant= past variant 250 is not in page 1. The section emits
       it on its own (data-role="url-variant", only when the URL names one), so it
       is merged in here and wins before the first refresh. The later page merge
       skips it by id, so it is never listed twice. */
    var urlVariantEl = root.querySelector('[data-role="url-variant"]');
    if (urlVariantEl) {
      try {
        var urlVariant = JSON.parse(urlVariantEl.textContent);
        if (urlVariant && urlVariant.id != null && !findVariantById(urlVariant.id)) variants.push(urlVariant);
      } catch (e) {}
    }

    var initialVariant = variantInput ? findVariantById(variantInput.value) : null;
    if (!initialVariant && variants.length) initialVariant = firstPreselectable(variants, sizeIdx, skipSizes);

    var state = {
      bike: bikeIdx > -1 && initialVariant ? initialVariant.options[bikeIdx] : (bikeSelect ? bikeSelect.value : staticBike),
      size: sizeIdx > -1 && initialVariant ? initialVariant.options[sizeIdx] : null,
      color: colorIdx > -1 && initialVariant ? initialVariant.options[colorIdx] : null
    };
    if (bikeSelect && state.bike) bikeSelect.value = state.bike;

    function matches(v, filter) {
      if (bikeIdx > -1 && filter.bike != null && v.options[bikeIdx] !== filter.bike) return false;
      if (sizeIdx > -1 && filter.size != null && v.options[sizeIdx] !== filter.size) return false;
      if (colorIdx > -1 && filter.color != null && v.options[colorIdx] !== filter.color) return false;
      return true;
    }

    function variantsFor(filter) {
      return variants.filter(function (v) { return matches(v, filter); });
    }

    function findVariant(bike, size, color) {
      var list = variantsFor({ bike: bike, size: size, color: color });
      return list[0] || null;
    }

    function updateSizeButtons() {
      if (!sizeButtons.length) return;
      var avail = null;
      if (sizeIdx > -1) {
        avail = {};
        variantsFor({ bike: state.bike }).forEach(function (v) { avail[v.options[sizeIdx]] = true; });
      }
      var offered = [];
      sizeButtons.forEach(function (btn) {
        var v = btn.dataset.value;
        var ok = !avail || avail[v];
        btn.hidden = !ok;
        if (ok) offered.push(v);
      });
      var stillValid = state.size && offered.indexOf(state.size) > -1;
      if (!stillValid) state.size = fallbackSize(offered, skipSizes);
      sizeButtons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(btn.dataset.value === state.size));
        /* The badge can depend on the bike (the Altis Sigma's supermoto size), so it
           follows every bike change. */
        var on = popularSize(btn.dataset.value);
        var badge = btn.querySelector('.rm-pop');
        if (on && !badge) btn.insertAdjacentHTML('afterbegin', POP_BADGE);
        else if (!on && badge) badge.parentNode.removeChild(badge);
      });
    }

    function updateColorButtons() {
      if (!colorButtons.length) return;
      var avail = null;
      if (colorIdx > -1) {
        avail = {};
        variantsFor({ bike: state.bike, size: state.size }).forEach(function (v) { avail[v.options[colorIdx]] = true; });
      }
      var firstEnabled = null;
      colorButtons.forEach(function (btn) {
        var v = btn.dataset.value;
        var ok = !avail || avail[v];
        btn.hidden = !ok;
        if (ok && !firstEnabled) firstEnabled = v;
      });
      var stillValid = state.color && colorButtons.some(function (b) { return b.dataset.value === state.color && !b.hidden; });
      if (!stillValid) {
        state.color = (avail && avail.Black) ? 'Black' : firstEnabled;
      }
      colorButtons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(btn.dataset.value === state.color));
      });
      updateColorPriceDiffs();
    }

    function updateColorPriceDiffs() {
      if (colorIdx < 0) return;
      var base = findVariant(state.bike, state.size, 'Black');
      colorButtons.forEach(function (btn) {
        var v = findVariant(state.bike, state.size, btn.dataset.value);
        var diffEl = btn.querySelector('[data-role="color-diff"]');
        if (!diffEl) return;
        if (v && base && Number(v.price) > Number(base.price)) {
          diffEl.textContent = '+' + money(Number(v.price) - Number(base.price));
        } else {
          diffEl.textContent = '';
        }
      });
    }

    function imagesForColor(color) {
      var seen = {};
      var out = [];
      variants.forEach(function (v) {
        if (colorIdx > -1 && color != null && v.options[colorIdx] !== color) return;
        if (!v.image || seen[v.image]) return;
        seen[v.image] = true;
        out.push(v.image);
      });
      /* Each colour carries a single variant image, so on its own this is a
         one-photo gallery. Follow it with the rest of the product's photos. */
      productMedia.forEach(function (src) {
        if (!src || seen[src]) return;
        seen[src] = true;
        out.push(src);
      });
      return out;
    }

    function bindThumbs() {
      galThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-role="gal-thumb"]'));
      galThumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (galImg) galImg.src = btn.dataset.src;
          galThumbs.forEach(function (b) { b.setAttribute('aria-current', String(b === btn)); });
        });
      });
    }

    /* The gallery list is 900px photos; the 80px thumbnails only need 160px.
       Loading the 900px file into every thumb cost about 1.6 MB per page
       (Lighthouse, 2026-09-25). */
    function thumbSrc(src) {
      return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1160') : src;
    }

    function renderGallery() {
      if (!galThumbsWrap || colorIdx < 0) return;
      var images = imagesForColor(state.color);
      if (!images.length) return;
      galThumbsWrap.innerHTML = images.map(function (src, i) {
        return '<button type="button" data-role="gal-thumb" data-src="' + src +
          '" aria-current="' + (i === 0) +
          '" aria-label="Show product image ' + (i + 1) + ' of ' + images.length + '">' +
          '<img src="' + thumbSrc(src) + '" alt="" width="80" height="80" loading="lazy">' +
          '</button>';
      }).join('');
      bindThumbs();
      if (galImg) galImg.src = images[0];
    }

    var lastNoteText = '';
    /* The fitment notes row for the bike and size in hand, kept so add to cart can
       name the standard tires even on a size with no tire choice. */
    var currentNoteRow = null;

    function refreshNote() {
      var row = null;
      if (notesData.length) {
        var noteBike = noteBikeFor(state.bike);
        row = noteBike ? notesData.filter(function (r) {
          return r.family === fam && r.bike === noteBike && r.size_label === state.size;
        })[0] || null : null;
      }
      currentNoteRow = row;
      if (sizeNoteEl) {
        var noteText = (row && row.notes)
          ? row.notes.split('|').map(function (s) { return s.trim(); }).filter(Boolean).join('. ')
          : '';
        if (noteText) {
          sizeNoteEl.textContent = noteText;
          sizeNoteEl.hidden = false;
          if (sizeConfirmWrap) {
            sizeConfirmWrap.hidden = false;
            /* A confirmation is per note. Moving to a different bike or size with a
               different note starts unticked so nobody confirms a note they never saw. */
            if (sizeConfirmInput && lastNoteText !== noteText) sizeConfirmInput.checked = false;
          }
        } else {
          sizeNoteEl.textContent = '';
          sizeNoteEl.hidden = true;
          if (sizeConfirmWrap) {
            sizeConfirmWrap.hidden = true;
            if (sizeConfirmInput) sizeConfirmInput.checked = false;
          }
        }
        lastNoteText = noteText;
      }
      renderTires();
      if (isRtr && rtrTireEl) {
        /* With the tire choice on screen the standard pairing is its first option,
           so the one-line "Included tires" note would say the same thing twice. */
        if (row && row.rtr_tire && !tireChoiceShown()) {
          var parts = row.rtr_tire.split('|').map(function (s) { return s.trim(); });
          var line = 'Included tires: ' + (parts[0] || '');
          if (parts[1]) line += ', ' + parts[1] + ' front';
          if (parts[2]) line += ', ' + parts[2] + ' rear';
          rtrTireEl.textContent = line + '.';
          rtrTireEl.hidden = false;
        } else {
          rtrTireEl.hidden = true;
        }
      }
      updateAtcState();
    }

    function updateAtcState() {
      var variant = findVariant(state.bike, state.size, state.color);
      var enabled = !!(variant && variant.available);
      if (sizeConfirmWrap && !sizeConfirmWrap.hidden && sizeConfirmInput && !sizeConfirmInput.checked) {
        enabled = false;
      }
      if (variantInput) variantInput.value = variant ? variant.id : '';
      if (atcBtn) atcBtn.disabled = !enabled;
      if (atcText) {
        atcText.textContent = !variant ? 'Select options' : (variant.available ? 'Add to cart' : 'Sold out');
      }
      if (priceEl && variant) priceEl.textContent = money(Number(variant.price) + chosenTireCents());
      /* Shop Pay and the other express buttons buy the selected variant alone and
         would drop the tire choice line, so they are hidden while a non-standard
         tire is picked and checkout goes through the cart (plan problem 7). */
      if (expressEl) expressEl.hidden = !!chosenTire();
      if (variant) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        } catch (e) {}
        if (variant.image && galImg) galImg.src = variant.image;
      }
    }

    /* ---------- Ready-to-Ride tire choice ----------
       assets/rm-rtr-tires.json lists, per product handle and Size value, the
       standard pairing and the options. Only options the hidden tire choice product
       really sells right now are shown: /products/rtr-tire-choice.js is read once
       and each option is matched to its variant by SKU, so the id and the price
       always come from the store, and a draft or missing product leaves the page
       exactly as it was (standard tires only). */
    var tireData = null;
    var tireVariants = null; /* SKU -> { id, price, available } from the probe */
    var tireState = { rowId: null, sku: '' };

    if (isRtr && tirePickEl && window.rmRtrTiresUrl) {
      fetch(window.rmRtrTiresUrl)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.products || !d.products[productHandle]) return null;
          tireData = d;
          return fetch('/products/' + encodeURIComponent(d.product_handle || 'rtr-tire-choice') + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (prod) {
              var map = {};
              ((prod && prod.variants) || []).forEach(function (v) {
                if (v && v.sku) map[v.sku] = { id: v.id, price: Number(v.price), available: !!v.available };
              });
              tireVariants = map;
            });
        })
        .catch(function () { tireVariants = null; })
        .then(function () { refreshNote(); });
    }

    function tireRow() {
      if (!tireData || !tireVariants) return null;
      var sizes = tireData.products[productHandle];
      var rowId = sizes && state.size ? sizes[state.size] : null;
      var row = rowId ? tireData.rows[rowId] : null;
      return row ? { id: rowId, row: row } : null;
    }

    function tireOptions() {
      var hit = tireRow();
      if (!hit) return [];
      var out = [];
      hit.row.options.forEach(function (o) {
        if (!o.enabled) return;
        var v = tireVariants[o.sku];
        if (!v || !v.available) return;
        out.push({ opt: o, id: v.id, cents: v.price });
      });
      return out;
    }

    function tireChoiceShown() {
      return !!(tirePickEl && !tirePickEl.hidden);
    }

    function chosenTire() {
      if (!tireState.sku || !tireChoiceShown()) return null;
      var list = tireOptions();
      for (var i = 0; i < list.length; i++) if (list[i].opt.sku === tireState.sku) return list[i];
      return null;
    }

    function chosenTireCents() {
      var c = chosenTire();
      return c ? c.cents : 0;
    }

    function esc(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    function tireOptHtml(value, checked, name, sizes, metas, priceText, popularTire) {
      var radioName = 'rm-tire-' + (root.dataset.sectionId || 'pdp');
      var bare = name.replace(/ \(standard\)$/, '');
      var use = tireUse(bare);
      var info = tireInfo(bare).length
        ? '<button type="button" class="rm-tireinfo" data-tireinfo="' + esc(value) + '" aria-haspopup="dialog">' +
          'Info<span class="visually-hidden"> about ' + esc(bare) + '</span></button>'
        : '';
      return '<label class="rm-tire-opt">' +
        '<input type="radio" name="' + radioName + '" value="' + esc(value) + '"' + (checked ? ' checked' : '') + '>' +
        '<span class="rm-tire-main">' + (popularTire ? POP_BADGE : '') + '<span class="rm-tire-name">' + esc(name) + '</span>' +
        (use ? '<span class="rm-tire-use">' + esc(use) + '</span>' : '') +
        '<span class="rm-tire-sz">' + esc(sizes) + '</span>' +
        metas.filter(Boolean).map(function (m) { return '<span class="rm-tire-meta">' + esc(m) + '</span>'; }).join('') +
        info +
        '</span><span class="rm-tire-price">' + esc(priceText) + '</span></label>';
    }

    /* ---------- tire terrain lines and Info popup (Peter, 2026-10-20) ----------
       Each tire's terrain line, short description and product handles live in
       snippets/rm-tire-info.liquid, shared with the custom builder. Info opens a
       dialog with the tire's photos large (the variant image for that size, from the
       tire's own product), the terrain line, the description and a button that picks
       it. A tire with no description shows no Info button. */
    var tireData2 = window.rmTireInfo || {};
    var tireProducts = tireData2.products || {};
    function tireUse(name) {
      return (tireData2.use || {})[String(name || '').toLowerCase().trim()] || '';
    }
    function tireInfo(name) {
      var all = tireData2.info || {};
      var key = String(name || '').toLowerCase().trim();
      if (all[key]) return [{ name: name, text: all[key] }];
      return String(name || '').split(' / ').map(function (n) {
        return { name: n.trim(), text: all[n.trim().toLowerCase()] || '' };
      }).filter(function (x) { return x.text; });
    }
    /* [{ pos, handle, size }] for a tire name and its two sizes. "A / B" is A on the
       front and B on the rear; a name the map lacks falls back to the option's own
       tire_handle (rm-rtr-tires.json). */
    function tireParts(name, front, rear, fallbackHandle) {
      var names = String(name || '').split(' / ');
      var f = tireProducts[names[0].trim().toLowerCase()];
      var r = tireProducts[(names[1] || names[0]).trim().toLowerCase()];
      return [
        { pos: 'F', handle: (f && f.front) || fallbackHandle, size: front },
        { pos: 'R', handle: (r && (r.rear || r.front)) || fallbackHandle, size: rear }
      ];
    }
    var tirePics = {}; /* handle -> Promise of { sizes: [[title, url]], images, url } or null */
    function imgSrc(img) {
      return img && typeof img === 'object' ? img.src || '' : img || '';
    }
    function loadTirePics(handle) {
      if (!handle) return Promise.resolve(null);
      if (!tirePics[handle]) {
        tirePics[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            return p ? {
              sizes: (p.variants || []).map(function (v) { return [String(v.title || ''), imgSrc(v.featured_image)]; }),
              images: (p.images || []).map(imgSrc),
              url: imgSrc(p.featured_image)
            } : null;
          })
          .catch(function () { return null; });
      }
      return tirePics[handle];
    }
    /* "120/70-17", "120/70ZR17" and "120/70R17" are one size (same rule as the builder). */
    function tireSizeKey(t) {
      return String(t || '').toUpperCase().replace(/\s*(?:ZR|R|-|X)\s*(\d{2})(?=\b)/, ' $1').trim();
    }
    function tirePicUrl(pics, size, pos) {
      if (!pics) return '';
      var want = tireSizeKey(size);
      for (var i = 0; i < pics.sizes.length; i++) {
        var t = tireSizeKey(pics.sizes[i][0]);
        if ((t === want || t.indexOf(want + ' ') === 0) && pics.sizes[i][1]) return pics.sizes[i][1];
      }
      var end = pos === 'R' ? 'rear' : 'front';
      var named = (pics.images || []).filter(function (u) {
        var f = String(u).split('?')[0].split('/').pop().toLowerCase();
        return f.indexOf(end) > -1 && f.indexOf('front-and-rear') === -1;
      });
      return named[0] || pics.url || '';
    }
    function sized(url, w) {
      url = String(url || '');
      if (url.indexOf('//') === 0) url = 'https:' + url;
      return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '';
    }
    var tireDlg = null;
    function tireInfoFor(value) {
      var hit = tireRow();
      if (!hit) return null;
      if (!value) {
        var std = hit.row.standard;
        return { value: '', name: std.name, front: std.front, rear: std.rear, parts: tireParts(std.name, std.front, std.rear, '') };
      }
      var c = tireOptions().filter(function (t) { return t.opt.sku === value; })[0];
      return c ? { value: value, name: c.opt.label, front: c.opt.front, rear: c.opt.rear, parts: tireParts(c.opt.label, c.opt.front, c.opt.rear, c.opt.tire_handle) } : null;
    }
    function openTireInfo(value) {
      var t = tireInfoFor(value);
      if (!t) return;
      if (!tireDlg) {
        tireDlg = document.createElement('dialog');
        tireDlg.className = 'rm-tdlg';
        tireDlg.setAttribute('aria-labelledby', 'rm-tdlg-title-' + (root.dataset.sectionId || 'pdp'));
        root.appendChild(tireDlg);
        tireDlg.addEventListener('click', function (e) {
          /* A click on the backdrop lands on the dialog itself. */
          if (e.target === tireDlg || e.target.closest('[data-tdlg-close]')) return tireDlg.close();
          var pick = e.target.closest('[data-tdlg-pick]');
          if (!pick) return;
          var v = pick.getAttribute('data-tdlg-pick');
          tireDlg.close();
          var input = Array.prototype.filter.call(tireListEl.querySelectorAll('input[type="radio"]'), function (i) { return i.value === v; })[0];
          if (input && !input.checked) input.click();
        });
      }
      var bare = t.name.replace(/ \(standard\)$/, '');
      var use = tireUse(bare);
      var info = tireInfo(bare);
      var isChosen = (tireState.sku || '') === t.value;
      var titleId = 'rm-tdlg-title-' + (root.dataset.sectionId || 'pdp');
      function paint(shots) {
        tireDlg.innerHTML =
          '<div class="rm-tdlg__head"><h3 id="' + titleId + '">' + esc(bare) + '</h3>' +
          '<button type="button" class="rm-tdlg__x" data-tdlg-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button></div>' +
          (use ? '<p class="rm-tdlg__use">' + esc(use) + '</p>' : '') +
          (shots === null
            ? '<div class="rm-tdlg__pics rm-tdlg__pics--wait" aria-hidden="true"></div>'
            : shots.length
              ? '<div class="rm-tdlg__pics">' + shots.map(function (x) {
                  return '<figure><img src="' + esc(sized(x.url, 600)) + '" alt="' + esc(bare + ' tire') + '" width="300" height="300">' +
                    '<figcaption>' + esc(x.cap) + '</figcaption></figure>';
                }).join('') + '</div>'
              : '<p class="rm-tdlg__sizes">' + esc(t.front + ' front / ' + t.rear + ' rear') + '</p>') +
          info.map(function (x) {
            return '<p class="rm-tdlg__text">' + (info.length > 1 ? '<b>' + esc(x.name) + '.</b> ' : '') + esc(x.text) + '</p>';
          }).join('') +
          '<div class="rm-tdlg__foot">' +
          (isChosen
            ? '<button type="button" class="rm-btn rm-btn-primary rm-tdlg__btn" data-tdlg-close>Close</button>'
            : '<button type="button" class="rm-btn rm-btn-primary rm-tdlg__btn" data-tdlg-pick="' + esc(t.value) + '">Choose these tires</button>') +
          '</div>';
      }
      paint(null);
      if (typeof tireDlg.showModal === 'function') { if (!tireDlg.open) tireDlg.showModal(); }
      else tireDlg.setAttribute('open', '');
      var parts = t.parts.filter(function (p) { return p.handle; });
      Promise.all(parts.map(function (p) { return loadTirePics(p.handle); })).then(function (all) {
        var shots = [];
        parts.forEach(function (p, i) {
          var url = tirePicUrl(all[i], p.size, p.pos);
          if (!url) return;
          var same = shots.filter(function (x) { return x.url === url; })[0];
          /* One photo for both ends (a tire sold for either) names both sizes. */
          if (same) same.cap = 'Front ' + t.front + ' / Rear ' + t.rear;
          else shots.push({ url: url, cap: (p.pos === 'R' ? 'Rear ' : 'Front ') + p.size });
        });
        if (tireDlg.open) paint(shots);
      });
    }

    function renderTires() {
      if (!tirePickEl || !tireListEl) return;
      var hit = tireRow();
      var list = tireOptions();
      if (!hit || !list.length) {
        tirePickEl.hidden = true;
        tireListEl.innerHTML = '';
        tireState.rowId = null;
        tireState.sku = '';
        return;
      }
      /* A new size starts on the standard tires, so nobody carries a choice made
         for other rims into a set it was not picked for. */
      if (tireState.rowId !== hit.id) {
        tireState.rowId = hit.id;
        tireState.sku = '';
      }
      if (tireState.sku && !list.some(function (t) { return t.opt.sku === tireState.sku; })) tireState.sku = '';
      var std = hit.row.standard;
      var html = tireOptHtml('', !tireState.sku, std.name + ' (standard)', std.front + ' front / ' + std.rear + ' rear', [], 'Included',
        (popular.standard_tire_rows || []).indexOf(hit.id) > -1);
      list.forEach(function (t) {
        var o = t.opt;
        html += tireOptHtml(o.sku, tireState.sku === o.sku, o.label, o.front + ' front / ' + o.rear + ' rear',
          [o.availability, o.fit_note], t.cents > 0 ? '+' + money(t.cents) : 'No extra charge');
      });
      /* Re-render only when the markup changes, so focus stays on the radio a
         keyboard user just moved to. */
      if (tireListEl.getAttribute('data-html') !== html) {
        tireListEl.innerHTML = html;
        tireListEl.setAttribute('data-html', html);
      }
      tirePickEl.hidden = false;
    }

    if (tireListEl) {
      /* The Info button sits inside the option's label, so its click must not pick it. */
      tireListEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tireinfo]');
        if (!b) return;
        e.preventDefault();
        e.stopPropagation();
        openTireInfo(b.getAttribute('data-tireinfo'));
      });
      tireListEl.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || t.type !== 'radio') return;
        tireState.sku = t.value || '';
        updateAtcState();
      });
    }

    /* The Tires line property: "Kenda Washougal III 70/100-19 / 90/100-16". A
       mixed standard ("Bridgestone Battlecross X30 / Kenda Washougal III") names
       each tire with its size. Same rule as scripts/rm-rtr-tires-build.py. */
    function pairingText(name, front, rear) {
      name = String(name || '').trim();
      if (name.indexOf(' / ') > -1) {
        var parts = name.split(' / ');
        return parts[0].trim() + ' ' + front + ' / ' + parts.slice(1).join(' / ').trim() + ' ' + rear;
      }
      return name + ' ' + front + ' / ' + rear;
    }

    function standardTiresText() {
      var hit = tireRow();
      if (hit && hit.row.standard && hit.row.standard.tires_text) return hit.row.standard.tires_text;
      if (currentNoteRow && currentNoteRow.rtr_tire) {
        var p = currentNoteRow.rtr_tire.split('|').map(function (x) { return x.trim(); });
        if (p[0] && p[1] && p[2]) return pairingText(p[0], p[1], p[2]);
      }
      return '';
    }

    /* Same alphabet and length as the custom builder's Build id (no 0, 1, i, l, o),
       new for every add, so two builds never share one. */
    function newBuildId() {
      var a = 'abcdefghjkmnpqrstuvwxyz23456789';
      var out = '';
      for (var i = 0; i < 8; i++) out += a.charAt(Math.floor(Math.random() * a.length));
      return out;
    }

    function refresh() {
      updateSizeButtons();
      updateColorButtons();
      renderGallery();
      refreshNote();
      updateBuilderLink();
    }

    if (bikeSelect) {
      bikeSelect.addEventListener('change', function () {
        state.bike = bikeSelect.value;
        state.size = null;
        state.color = null;
        refresh();
      });
    }

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.hidden) return;
        state.size = btn.dataset.value;
        refresh();
      });
    });

    colorButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.hidden) return;
        state.color = btn.dataset.value;
        refresh();
      });
    });

    if (sizeConfirmInput) {
      sizeConfirmInput.addEventListener('change', updateAtcState);
    }

    bindThumbs();

    refresh();

    if (variantPages > 1) {
      var sectionId = root.dataset.sectionId;
      var productUrl = root.dataset.productUrl;
      var seenIds = {};
      variants.forEach(function (v) { seenIds[v.id] = true; });
      var pending = [];
      for (var pg = 1; pg <= variantPages; pg++) {
        if (pg === loadedPage) continue;
        pending.push(pg);
      }
      Promise.all(pending.map(function (pg) {
        var url = productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') +
          'section_id=' + encodeURIComponent(sectionId) + '&page=' + pg;
        return fetch(url, { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html) return null;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var el = doc.querySelector('[data-role="variants-data"]');
            if (!el) return null;
            try { return JSON.parse(el.textContent); } catch (e) { return null; }
          })
          .catch(function () { return null; });
      })).then(function (results) {
        var added = 0;
        results.forEach(function (d) {
          if (!d || !d.variants) return;
          d.variants.forEach(function (v) {
            if (seenIds[v.id]) return;
            seenIds[v.id] = true;
            variants.push(v);
            added++;
          });
        });
        if (added) refresh();
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart();
      });
    }

    function setPending(isPending) {
      if (atcBtn) atcBtn.disabled = isPending;
      if (atcText) atcText.textContent = isPending ? 'Adding…' : 'Add to cart';
    }

    function addToCart() {
      var variant = findVariant(state.bike, state.size, state.color);
      if (!variant || !variant.available || !cartAddUrl) return;

      /* Standard tires: the wheelset line alone, as before, now naming its tires.
         A chosen option: the wheelset and the tire choice line in one call, which
         Shopify applies all or nothing. Both carry Tires and the same "_Build id"
         (leading underscore, so checkout and the order notification hide it; the
         cart groups on either "_Build id" or the builder's "Build id");
         the tire line also carries For, which is how the cart tells an add-on line
         from the wheelset it belongs to (the builder's rule). */
      var items = [{ id: variant.id, quantity: 1 }];
      var stdText = isRtr ? standardTiresText() : '';
      var tire = isRtr ? chosenTire() : null;
      if (tire) {
        var bid = newBuildId();
        items[0].properties = { Tires: tire.opt.tires_text, '_Build id': bid };
        /* Shopify lists the lines of one add in reverse, so the tire line goes
           first here and shows directly under its wheelset in the cart. */
        items.unshift({
          id: tire.id,
          quantity: 1,
          properties: { For: productTitle + (state.size ? ', ' + state.size : ''), Tires: tire.opt.tires_text, '_Build id': bid }
        });
      } else if (stdText) {
        items[0].properties = { Tires: stdText };
      }

      var resolveFn, rejectFn;
      var promise = new Promise(function (res, rej) { resolveFn = res; rejectFn = rej; });
      var evt = new Event(CART_LINES_UPDATE, { bubbles: true, cancelable: true });
      evt.action = 'add';
      evt.context = 'product';
      evt.lines = items.map(function (it) { return { merchandiseId: 'gid://shopify/ProductVariant/' + it.id, quantity: it.quantity }; });
      evt.promise = promise;
      document.dispatchEvent(evt);

      setPending(true);

      fetch(cartAddUrl.replace(/\.js$/, '') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json && json.status) {
            resolveFn({
              cart: null,
              detail: { didError: true, items: [], source: 'rm-blackline-product', sourceId: 'rm-blackline-form', itemCount: 0, productId: productId }
            });
            setPending(false);
            if (atcText) atcText.textContent = 'Could not add, try again';
            setTimeout(function () { updateAtcState(); }, 3000);
            return;
          }
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            resolveFn({
              cart: { totalQuantity: cart.item_count },
              detail: { items: cart.items, source: 'rm-blackline-product', sourceId: 'rm-blackline-form', itemCount: items.length, productId: productId, didError: false }
            });
            setPending(false);
          });
        })
        .catch(function (err) {
          rejectFn(err);
          setPending(false);
          if (atcText) atcText.textContent = 'Network error, try again';
          setTimeout(function () { updateAtcState(); }, 3000);
        });
    }
  }

  document.querySelectorAll('rm-blackline-pdp').forEach(init);
})();
